export default {"src":"/_next/static/media/bitcoin.f422d9fe.svg","height":57,"width":50,"blurWidth":0,"blurHeight":0};